import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-[68px]">
        <div className="w-full px-4 md:px-8 py-20 md:py-28">
          <div className="max-w-2xl">
            <span className="font-heading text-6xl md:text-8xl text-primary-200">404</span>
            <h1 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950">
              这条瓜好像被摘走了
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              你要找的页面不存在，可能是链接过期或者地址输错了。
            </p>
            <p className="mt-2 text-xs text-foreground-400 break-all">当前路径：{location.pathname}</p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/"
                className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm text-center whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                回到首页
              </Link>
              <Link
                to="/topics"
                className="px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm text-center whitespace-nowrap hover:border-primary-300 transition-colors"
              >
                去逛吃瓜热榜
              </Link>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}